import ComboBox from "../core/ComboBox";
import Badge from "../core/Badge";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronDown, faCheck } from "@fortawesome/free-solid-svg-icons";

const PRIORITY_VALUES = ["low", "medium", "high", "urgent"];
const PRIORITY_COLORS = {
  low: "#00f30f",
  medium: "#fae204",
  high: "#f97316",
  urgent: "#ff0000",
};

const PriorityDropdown = ({
  currentPriorityValue = "low",
  showDropdown,
  onToggle,
  onClose,
  onSelect,
}) => {
  const normalizedPriority = currentPriorityValue.toLowerCase();
  const priorityOptions = PRIORITY_VALUES.map((value) => ({
    priority_value: value,
    name: value.charAt(0).toUpperCase() + value.slice(1),
    color: PRIORITY_COLORS[value],
  }));

  const selectedPriority = priorityOptions.find(
    (option) => option.priority_value === normalizedPriority
  );

  const selectedItems = selectedPriority ? [selectedPriority] : [];
  const displayLabel = selectedPriority?.name || "None";
  const displayColor = selectedPriority?.color;

  return (
    <div className="inline-select">
      <button
        type="button"
        className="inline-select-trigger"
        onClick={(e) => {
          e.stopPropagation();
          onToggle();
        }}
      >
        <Badge type="priority" status={displayLabel} color={displayColor} />
        <FontAwesomeIcon
          icon={faChevronDown}
          className="inline-select-chevron"
        />
      </button>
      {showDropdown && (
        <div className="inline-select-dropdown">
          <ComboBox
            data={priorityOptions}
            selected={selectedItems}
            valueKey="priority_value"
            placeholder="Search priority..."
            searchTopic="priority"
            formatData={(option) => (
              <div className="inline-option">
                <span
                  className="inline-option-color"
                  style={{
                    backgroundColor: option.color || "var(--border-color)",
                  }}
                />
                <span>{option.name}</span>
                {normalizedPriority === option.priority_value && (
                  <FontAwesomeIcon
                    icon={faCheck}
                    className="inline-option-check"
                  />
                )}
              </div>
            )}
            handleSelect={(priorityValue) => {
              onSelect(priorityValue);
              onClose();
            }}
            onRequestClose={onClose}
            inline={true}
          />
        </div>
      )}
    </div>
  );
};

export default PriorityDropdown;
